<button
  [class]="'btn ' + classes + ' mx-2'"
  mat-raised-button
  (click)="press($event)"
  [style]="'background-color: ' + color + '; ' + 'color: ' + text + '; ' + deep"
  [disabled]="disabled">
  <ng-content></ng-content>
</button>
